/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AccreditationTypeEnum,
    AccreditationTypeEnumFromJSON,
    AccreditationTypeEnumFromJSONTyped,
    AccreditationTypeEnumToJSON,
} from './AccreditationTypeEnum';
import {
    MasterCategoryEnum,
    MasterCategoryEnumFromJSON,
    MasterCategoryEnumFromJSONTyped,
    MasterCategoryEnumToJSON,
} from './MasterCategoryEnum';
import {
    StudyCycleEnum,
    StudyCycleEnumFromJSON,
    StudyCycleEnumFromJSONTyped,
    StudyCycleEnumToJSON,
} from './StudyCycleEnum';
import {
    StudyProgramLangEnum,
    StudyProgramLangEnumFromJSON,
    StudyProgramLangEnumFromJSONTyped,
    StudyProgramLangEnumToJSON,
} from './StudyProgramLangEnum';

/**
 * 
 * @export
 * @interface StudyProgramQueryParams
 */
export interface StudyProgramQueryParams {
    /**
     * 
     * @type {number}
     * @memberof StudyProgramQueryParams
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof StudyProgramQueryParams
     */
    pageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof StudyProgramQueryParams
     */
    namePattern?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof StudyProgramQueryParams
     */
    facultyIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof StudyProgramQueryParams
     */
    domainIds?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof StudyProgramQueryParams
     */
    universityCenterId?: string;
    /**
     * 
     * @type {StudyCycleEnum}
     * @memberof StudyProgramQueryParams
     */
    studyCycle?: StudyCycleEnum;
    /**
     * 
     * @type {Array<StudyProgramLangEnum>}
     * @memberof StudyProgramQueryParams
     */
    studyProgramLanguageOptions?: Array<StudyProgramLangEnum> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof StudyProgramQueryParams
     */
    ectsOptions?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof StudyProgramQueryParams
     */
    externalEvaluationOptions?: Array<string> | null;
    /**
     * 
     * @type {Array<AccreditationTypeEnum>}
     * @memberof StudyProgramQueryParams
     */
    accreditationTypeOptions?: Array<AccreditationTypeEnum> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof StudyProgramQueryParams
     */
    capacityOptions?: Array<number> | null;
    /**
     * 
     * @type {Array<MasterCategoryEnum>}
     * @memberof StudyProgramQueryParams
     */
    masterCategoryOptions?: Array<MasterCategoryEnum> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof StudyProgramQueryParams
     */
    ancNoticeDateOptions?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof StudyProgramQueryParams
     */
    ancExpirationDateOptions?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof StudyProgramQueryParams
     */
    aracisExpirationDateOptions?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof StudyProgramQueryParams
     */
    ocuppationSearchTerm?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyProgramQueryParams
     */
    codCorSearchTerm?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StudyProgramQueryParams
     */
    isEurAceCertified?: boolean | null;
}

export function StudyProgramQueryParamsFromJSON(json: any): StudyProgramQueryParams {
    return StudyProgramQueryParamsFromJSONTyped(json, false);
}

export function StudyProgramQueryParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): StudyProgramQueryParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'namePattern': !exists(json, 'namePattern') ? undefined : json['namePattern'],
        'facultyIds': !exists(json, 'facultyIds') ? undefined : json['facultyIds'],
        'domainIds': !exists(json, 'domainIds') ? undefined : json['domainIds'],
        'universityCenterId': !exists(json, 'universityCenterId') ? undefined : json['universityCenterId'],
        'studyCycle': !exists(json, 'studyCycle') ? undefined : StudyCycleEnumFromJSON(json['studyCycle']),
        'studyProgramLanguageOptions': !exists(json, 'studyProgramLanguageOptions') ? undefined : (json['studyProgramLanguageOptions'] === null ? null : (json['studyProgramLanguageOptions'] as Array<any>).map(StudyProgramLangEnumFromJSON)),
        'ectsOptions': !exists(json, 'ectsOptions') ? undefined : json['ectsOptions'],
        'externalEvaluationOptions': !exists(json, 'externalEvaluationOptions') ? undefined : json['externalEvaluationOptions'],
        'accreditationTypeOptions': !exists(json, 'accreditationTypeOptions') ? undefined : (json['accreditationTypeOptions'] === null ? null : (json['accreditationTypeOptions'] as Array<any>).map(AccreditationTypeEnumFromJSON)),
        'capacityOptions': !exists(json, 'capacityOptions') ? undefined : json['capacityOptions'],
        'masterCategoryOptions': !exists(json, 'masterCategoryOptions') ? undefined : (json['masterCategoryOptions'] === null ? null : (json['masterCategoryOptions'] as Array<any>).map(MasterCategoryEnumFromJSON)),
        'ancNoticeDateOptions': !exists(json, 'ancNoticeDateOptions') ? undefined : json['ancNoticeDateOptions'],
        'ancExpirationDateOptions': !exists(json, 'ancExpirationDateOptions') ? undefined : json['ancExpirationDateOptions'],
        'aracisExpirationDateOptions': !exists(json, 'aracisExpirationDateOptions') ? undefined : json['aracisExpirationDateOptions'],
        'ocuppationSearchTerm': !exists(json, 'ocuppationSearchTerm') ? undefined : json['ocuppationSearchTerm'],
        'codCorSearchTerm': !exists(json, 'codCorSearchTerm') ? undefined : json['codCorSearchTerm'],
        'isEurAceCertified': !exists(json, 'isEurAceCertified') ? undefined : json['isEurAceCertified'],
    };
}

export function StudyProgramQueryParamsToJSON(value?: StudyProgramQueryParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'pageSize': value.pageSize,
        'namePattern': value.namePattern,
        'facultyIds': value.facultyIds,
        'domainIds': value.domainIds,
        'universityCenterId': value.universityCenterId,
        'studyCycle': StudyCycleEnumToJSON(value.studyCycle),
        'studyProgramLanguageOptions': value.studyProgramLanguageOptions === undefined ? undefined : (value.studyProgramLanguageOptions === null ? null : (value.studyProgramLanguageOptions as Array<any>).map(StudyProgramLangEnumToJSON)),
        'ectsOptions': value.ectsOptions,
        'externalEvaluationOptions': value.externalEvaluationOptions,
        'accreditationTypeOptions': value.accreditationTypeOptions === undefined ? undefined : (value.accreditationTypeOptions === null ? null : (value.accreditationTypeOptions as Array<any>).map(AccreditationTypeEnumToJSON)),
        'capacityOptions': value.capacityOptions,
        'masterCategoryOptions': value.masterCategoryOptions === undefined ? undefined : (value.masterCategoryOptions === null ? null : (value.masterCategoryOptions as Array<any>).map(MasterCategoryEnumToJSON)),
        'ancNoticeDateOptions': value.ancNoticeDateOptions,
        'ancExpirationDateOptions': value.ancExpirationDateOptions,
        'aracisExpirationDateOptions': value.aracisExpirationDateOptions,
        'ocuppationSearchTerm': value.ocuppationSearchTerm,
        'codCorSearchTerm': value.codCorSearchTerm,
        'isEurAceCertified': value.isEurAceCertified,
    };
}

